// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ccbce148","455":"71737614","977":"e4ffb4b9"}[chunkId] + ".chunk.js";
};